import * as Joi from 'joi';
import _ from 'lodash';
import { CLIENT_STATE_KEYS, CLIENT_STATE_VERSIONS, DEFAULT_AXIS_EXTREMES, DEFAULT_PIVOT_STATE, DEFAULT_RANGE_PARAMS, getDefaultPropsFromDefaultValues, getUpdatedFormatConfig, } from '../../client-state-type';
import { getUpdatedConditionalFormatting } from '../../conditional-formatting-upgrade-util';
import { ChartResponsiveLayout, ChartVizPropVersion, } from '../../types/prism';
import { DEFAULT_AXIS_PROPERTIES } from '../chart-axis';
import { CHART_RESPONSIVE_LAYOUT_V2 } from '../types/v2';
import { ClientStateV3Schema } from '../types/v3';
import { ClientStateV4dot1Class, DEFAULT_CHART_SPECIFICV4dot1, } from '../types/v4dot1';
const DeprecatedToResponsiveLayoutMap = {
    [CHART_RESPONSIVE_LAYOUT_V2.USER_PREFERRED_ON]: ChartResponsiveLayout.UserPreferredOn,
    [CHART_RESPONSIVE_LAYOUT_V2.USER_PREFERRED_OFF]: ChartResponsiveLayout.UserPreferredOff,
    [CHART_RESPONSIVE_LAYOUT_V2.AUTO_ON]: ChartResponsiveLayout.AutoOn,
    [CHART_RESPONSIVE_LAYOUT_V2.AUTO_OFF]: ChartResponsiveLayout.AutoOff,
    1: ChartResponsiveLayout.UserPreferredOn,
    2: ChartResponsiveLayout.UserPreferredOff,
    3: ChartResponsiveLayout.AutoOn,
    4: ChartResponsiveLayout.AutoOff,
};
export var SortBy;
(function (SortBy) {
    SortBy["NONE"] = "none";
    SortBy["VALUE"] = "value";
})(SortBy || (SortBy = {}));
function getUpdatedPivotPaths(pivotStatePaths) {
    if (!pivotStatePaths || !pivotStatePaths.length) {
        return [];
    }
    return pivotStatePaths.map(paths => {
        return {
            __typename: 'PivotPaths',
            paths,
        };
    });
}
export function isSortingStateSaved(field) {
    const result = field.sortBySummaryField || field.sortBy === SortBy.NONE;
    return !!result;
}
function getUpdatedPivotFields(fields) {
    if (!fields || !fields.length) {
        return [];
    }
    return fields
        .filter(field => {
        return isSortingStateSaved(field) || field.expanded;
    })
        .map(field => {
        return {
            __typename: 'PivotField',
            dataField: field.dataField,
            sortBy: field.sortBy || '',
            sortBySummaryField: field.sortBySummaryField || '',
            sortBySummaryPath: field.sortBySummaryPath || [],
            sortOrder: field.sortOrder || '',
            expanded: field.expanded || false,
            area: field.area,
        };
    });
}
function getPivotStatePropsFromDXPivotState(pivotState) {
    return {
        ...DEFAULT_PIVOT_STATE,
        columnExpandedPaths: getUpdatedPivotPaths(pivotState.columnExpandedPaths),
        rowExpandedPaths: getUpdatedPivotPaths(pivotState.rowExpandedPaths),
        fields: getUpdatedPivotFields(pivotState.fields),
    };
}
function getUpdatedChartPropertiesForV4(clientState) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const chartProperties = _.get(clientState, CLIENT_STATE_KEYS.chartProperties);
    return chartProperties
        ? {
            allLabels: (_a = chartProperties.allLabels) !== null && _a !== void 0 ? _a : null,
            axisExtremes: chartProperties.axisExtremes
                ? {
                    ...DEFAULT_AXIS_EXTREMES,
                    x: chartProperties.axisExtremes.x
                        ? chartProperties.axisExtremes.x.map(rangeParam => {
                            var _a, _b;
                            return ({
                                ...DEFAULT_RANGE_PARAMS,
                                max: (_a = rangeParam.max) !== null && _a !== void 0 ? _a : null,
                                min: (_b = rangeParam.min) !== null && _b !== void 0 ? _b : null,
                            });
                        })
                        : [],
                    y: chartProperties.axisExtremes.y
                        ? chartProperties.axisExtremes.y.map(rangeParam => {
                            var _a, _b;
                            return ({
                                ...DEFAULT_RANGE_PARAMS,
                                max: (_a = rangeParam.max) !== null && _a !== void 0 ? _a : null,
                                min: (_b = rangeParam.min) !== null && _b !== void 0 ? _b : null,
                            });
                        })
                        : [],
                }
                : null,
            dataSize: (_b = chartProperties.dataSize) !== null && _b !== void 0 ? _b : null,
            gridLines: chartProperties.gridLines
                ? {
                    __typename: 'GridLineProperties',
                    xGridlineEnabled: (_c = chartProperties.gridLines.xGridlineEnabled) !== null && _c !== void 0 ? _c : null,
                    yGridlineEnabled: (_d = chartProperties.gridLines.yGridlineEnabled) !== null && _d !== void 0 ? _d : null,
                }
                : null,
            isZoomed: (_e = chartProperties.isZoomed) !== null && _e !== void 0 ? _e : null,
            mapviewport: chartProperties.mapviewport
                ? {
                    __typename: 'MapViewport',
                    center: (_f = chartProperties.mapviewport.center) !== null && _f !== void 0 ? _f : null,
                    zoomLevel: (_g = chartProperties.mapviewport.zoomLevel) !== null && _g !== void 0 ? _g : null,
                }
                : null,
            responsiveLayoutDisabled: (_h = chartProperties.responsiveLayoutDisabled) !== null && _h !== void 0 ? _h : null,
            showLinearRegressionLine: (_j = chartProperties.showLinearRegressionLine) !== null && _j !== void 0 ? _j : null,
            showStackedLabels: (_k = chartProperties.showStackedLabels) !== null && _k !== void 0 ? _k : null,
            visibleSeriesNames: chartProperties.visibleSeriesNames || [],
            chartSpecific: chartProperties.chartSpecific
                ? {
                    ...DEFAULT_CHART_SPECIFICV4dot1,
                    hidePivotSummaries: (_l = chartProperties.chartSpecific.hidePivotSummaries) !== null && _l !== void 0 ? _l : null,
                    isHeatmapOverlayed: (_m = chartProperties.chartSpecific.isHeatmapOverlayed) !== null && _m !== void 0 ? _m : null,
                    isStackedAsPercent: (_o = chartProperties.chartSpecific.isStackedAsPercent) !== null && _o !== void 0 ? _o : null,
                    markersEnabled: (_p = chartProperties.chartSpecific.markersEnabled) !== null && _p !== void 0 ? _p : null,
                    summaryMode: (_q = chartProperties.chartSpecific.summaryMode) !== null && _q !== void 0 ? _q : null,
                    useFlatLayout: (_r = chartProperties.chartSpecific.useFlatLayout) !== null && _r !== void 0 ? _r : null,
                    pivotState: chartProperties.chartSpecific.pivotState
                        ? getPivotStatePropsFromDXPivotState(chartProperties.chartSpecific.pivotState)
                        : null,
                    summaryFormat: getUpdatedFormatConfig(chartProperties.chartSpecific.summaryFormat),
                    stackedAsPercentFormat: getUpdatedFormatConfig(chartProperties.chartSpecific
                        .stackedAsPercentFormat),
                }
                : null,
            responsiveLayoutPreference: chartProperties.responsiveLayoutPreference
                ? DeprecatedToResponsiveLayoutMap[chartProperties.responsiveLayoutPreference]
                : null,
            __typename: 'ChartProperties',
        }
        : null;
}
function getUpdatedSeriesColorForV4(clientState, clientStateKey) {
    const seriesColor = _.get(clientState, clientStateKey);
    const updatedSeriesColor = [];
    _.forEach(seriesColor, (color, serieName) => {
        updatedSeriesColor.push({
            __typename: 'SeriesColor',
            serieName: !_.isNil(serieName)
                ? serieName.toString().toLowerCase()
                : null,
            color: color || null,
        });
    });
    return updatedSeriesColor;
}
function getUpdatedMultiSeriesColorForV4(clientState, clientStateKey) {
    const multiSeriesColor = _.get(clientState, clientStateKey) || {};
    const updatedMultiSeriesColor = [];
    _.forEach(multiSeriesColor, (colorMap, serieName) => {
        const updatedColorMap = Object.keys(colorMap).map(xAxisColumnHash => {
            return {
                __typename: 'SeriesMultiColorMap',
                serieName: !_.isNil(xAxisColumnHash)
                    ? xAxisColumnHash.toString().toLowerCase()
                    : null,
                color: colorMap[xAxisColumnHash] || [],
            };
        });
        updatedMultiSeriesColor.push({
            __typename: 'MultiSeriesColorMap',
            serieName: !_.isNil(serieName)
                ? serieName.toString().toLowerCase()
                : null,
            colorMap: updatedColorMap || [],
        });
    });
    return updatedMultiSeriesColor;
}
function getUpdatedAxisPropertiesForV4(clientState) {
    const axisProperties = _.get(clientState, CLIENT_STATE_KEYS.axisProperties);
    const updatedAxisProperties = [];
    Object.keys(axisProperties).forEach(axisId => {
        var _a, _b;
        updatedAxisProperties.push({
            __typename: 'AxisObj',
            id: axisId,
            properties: {
                ...getDefaultPropsFromDefaultValues(DEFAULT_AXIS_PROPERTIES, axisProperties[axisId]),
                yAxisRange: axisProperties[axisId].yAxisRange
                    ? {
                        __typename: 'RangeParam',
                        max: (_a = axisProperties[axisId].yAxisRange.max) !== null && _a !== void 0 ? _a : null,
                        min: (_b = axisProperties[axisId].yAxisRange.min) !== null && _b !== void 0 ? _b : null,
                    }
                    : null,
                format: getUpdatedFormatConfig(axisProperties[axisId].format),
            },
        });
    });
    return updatedAxisProperties;
}
function getUpdatedColumnPropertiesForV4(clientState, vizModel) {
    const columnProperties = _.get(clientState, CLIENT_STATE_KEYS.columnProperties) || {};
    const vizColumn = vizModel.columns;
    const updatedColumnProperties = [];
    _.forEach(vizColumn, col => {
        const chartColumnPropertyMap = {
            __typename: 'ChartColumnPropertyMap',
            columnId: col.id,
            columnProperty: {
                __typename: 'ChartVizColumnProperties',
                dataLabels: _.get(columnProperties, [col.id, CLIENT_STATE_KEYS.dataLabels], null),
                conditionalFormatting: getUpdatedConditionalFormatting(col),
            },
        };
        updatedColumnProperties.push(chartColumnPropertyMap);
    });
    return updatedColumnProperties;
}
const upgradeV3ToV4dot1 = (clientState, vizModel) => {
    const newClientState = {
        __typename: 'ChartVizProps',
        axisProperties: getUpdatedAxisPropertiesForV4(clientState),
        chartProperties: getUpdatedChartPropertiesForV4(clientState),
        columnProperties: getUpdatedColumnPropertiesForV4(clientState, vizModel),
        customColorSelectorArray: _.get(clientState, 'custom_color_selector_array') || [],
        seriesColors: getUpdatedSeriesColorForV4(clientState, CLIENT_STATE_KEYS.SERIES_COLORS),
        systemSeriesColors: getUpdatedSeriesColorForV4(clientState, CLIENT_STATE_KEYS.SYSTEM_SERIES_COLORS),
        multiColorSeriesColors: getUpdatedMultiSeriesColorForV4(clientState, CLIENT_STATE_KEYS.MULTI_COLOR_SERIES_COLORS),
        systemMultiColorSeriesColors: getUpdatedMultiSeriesColorForV4(clientState, CLIENT_STATE_KEYS.SYSTEM_MULTI_COLOR_SERIES_COLORS),
        version: ChartVizPropVersion.V4Dot1,
    };
    const clientStateV4 = new ClientStateV4dot1Class();
    _.assign(clientStateV4, newClientState);
    return clientStateV4;
};
const upgraderFn = (clientState, vizModel) => {
    Joi.assert(clientState, ClientStateV3Schema);
    const clientStateVersion = _.get(clientState, CLIENT_STATE_KEYS.version);
    if (clientStateVersion !== CLIENT_STATE_VERSIONS.V3) {
        throw new Error(`incompatible client state received in chart upgrade path for v3 to v4.1 with version no:${clientStateVersion}`);
    }
    return upgradeV3ToV4dot1(clientState, vizModel);
};
const testHooks = {
    upgradeV3ToV4dot1,
};
export { upgraderFn, DeprecatedToResponsiveLayoutMap, getPivotStatePropsFromDXPivotState, getUpdatedPivotFields, getUpdatedChartPropertiesForV4, getUpdatedColumnPropertiesForV4, getUpdatedMultiSeriesColorForV4, getUpdatedSeriesColorForV4, testHooks, };
//# sourceMappingURL=v3-to-v4dot1.js.map